import { getApi,postApi } from "../../config/api";

export const GoalPositionService = {

    "CollectorX": async function (){
        return false;
    },

    "CollectorY": async function (){
        return false;
    },

    "CollectorZ": async function (){
        return false;
    },

    "CollectorA": async function (){
        return false;
    },

    "MixerX": async function (){
        return false;
    },

    "MixerY": async function (){
        return false;
    },

    "MixerA": async function (){
        return false;
    },

    "MoveCollector": async function (payload,kitchenId){
        return await postApi("/performTask?taskName=move_collector_to_coordiate",payload,kitchenId);
    },

    "MoveMixer": async function (payload,kitchenId){
        return await postApi("/performTask?taskName=move_mixer_to_coordiate",payload,kitchenId);
    },
};